import React from 'react';

interface InputPillProps {
    text: string;
    className?: string;
    onClick?: () => void;
    'aria-pressed'?: boolean;
}

const InputPill: React.FC<InputPillProps> = ({
    text,
    className,
    onClick,
    'aria-pressed': ariaPressed,
}) => (
    <button
        type="button"
        className={className}
        onClick={onClick}
        aria-pressed={ariaPressed}
        tabIndex={0}
    >
        {text}
    </button>
);

export {InputPill};
